import { config } from '@iheartjane/config';
import { Mfa, getMfaContactDisplay, useMfa } from '@iheartjane/menu';
import { Modal } from '@iheartjane/reefer';

import { useJaneUser } from '@jane/shared/data-access';
import { inIframe } from '@jane/shared/util';

// The MFA modal must exist within the MfaProvider.
export const MfaModal = () => {
  const {
    canResendCode,
    canSendCode,
    codeResent,
    codeSent,
    errorSendingCode,
    errorVerifyingCode,
    getNewPhone,
    mfaCancel,
    open,
    resendCode,
    sendCode,
    sendingCode,
    verifyCode,
  } = useMfa();
  const { data: userData } = useJaneUser();
  const isInIframe = inIframe();

  const newPhone = getNewPhone();
  const usesEmail = !!config.useEmailOverSMS && !config.mfaForceSMS;
  const contactDisplay = getMfaContactDisplay({
    user: userData?.user,
    newPhone,
    usesEmail,
  });

  return (
    <Modal
      variant="dialogue"
      open={open}
      onRequestClose={mfaCancel}
      topOverride={isInIframe ? (open ? '160px' : '350px') : undefined}
    >
      <Modal.Content>
        <Mfa
          autoSendCode={canSendCode()}
          codeResent={codeResent}
          codeSent={codeSent}
          contactDisplay={contactDisplay}
          errorSendingCode={errorSendingCode}
          errorVerifyingCode={errorVerifyingCode}
          newPhone={!!newPhone}
          onCancel={mfaCancel}
          resendCode={resendCode}
          sendCode={sendCode}
          sendingCode={sendingCode}
          showResendButton={canResendCode()}
          usesEmail={usesEmail}
          verifyCode={verifyCode}
        />
      </Modal.Content>
    </Modal>
  );
};
